// src/hooks/useAppSelectors.ts
import { useSelector } from 'react-redux';
import { RootState } from '@/store'; // update path as per your project

export const useAuthToken = () => useSelector((state: RootState) => state.tokenReducer.token);
